import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

declare global {
  interface Window {
    AwsWafIntegration: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AWSInterceptor implements HttpInterceptor {
  constructor() { }
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('AWSInterceptor: Processing request', request.url);
    
    const params = request.params;
    const headers = request.headers;
    const body = request.body;
    
    if (request.url && !request.url.includes("vertofx")) {
      console.log('AWSInterceptor: Not a vertofx URL, passing through');
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          return event;
        })
      );
    } 

    if(!window.AwsWafIntegration) {
      console.error("AWS WAF Integration is not available");
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          return event;
        })
      );
    }

    return from(window.AwsWafIntegration.getToken()).pipe(
      switchMap((token: any) => {
        if (request.url?.includes("vertofx")) {
          const clonedRequest = request.clone({
            params,
            headers: headers.set('x-aws-waf-token', token.toString()),
            body
          });

          return next.handle(clonedRequest).pipe(
            map((event: HttpEvent<any>) => {
              return event;
            })
          );
        } else {
          return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
              return event;
            })
          );
        }
      }),
      catchError((ex) => {
        console.log("Exception in AWS Interceptor ", ex);
        return throwError(() => ex);
      })
    );
  }
}
